(function () {
  'use strict';

  var SPC_CATEGORY = 'furlers'; // updated by switchCategory()

  // ─── STATE ───────────────────────────────────────────────────────────────────
  var S = {
    activePart:    null,
    isLive:        false,
    currentParts:  [],
    assemblyName:  'Furler assembly (demo)',
    hierarchy:     null,
    subcatGroups:  {},
    activeSubcat:  null,
  };

  // ─── DEMO DATA (per category) ─────────────────────────────────────────────────
  var DEMO_PARTS = {
    furlers: [
      { ref: 1, name: 'Top Swivel Replacements',   desc: 'Upper halyard swivel assemblies and bearing units for headsail and genoa furlers. Available for Harken, Profurl, Facnor, Selden, and other major brands — select your model above to find the correct part.' },
      { ref: 2, name: 'Foil & Extrusion Sections', desc: 'Luff groove foil sections and extrusion replacement parts. Sold individually or in kits — specify your furler brand and model for the correct profile and length.' },
      { ref: 3, name: 'Drum Assembly Replacements',desc: 'Complete furling drum assemblies and individual drum components including cage, rotating nose cone, and fasteners. Available for all major furler brands.' },
      { ref: 4, name: 'Bearing Assemblies',        desc: 'Thrust bearings and bearing kits for furler head swivels and drum bases. Critical maintenance components — replace during any full furler rebuild to restore smooth operation.' },
      { ref: 5, name: 'Toggle & Tack Fittings',    desc: 'Lower toggle, tack plates, and clevis pin sets for furler tack attachment. Sized by wire diameter and load rating — select brand and model above for a direct fit.' },
    ],
    winches: [
      { ref: 1, name: 'Top Caps & Handle Sockets', desc: 'Top cover plates and ratcheting handle socket assemblies for self-tailing and standard winches. Match your winch brand and size for correct fitment.' },
      { ref: 2, name: 'Drum & Barrel Replacements',desc: 'Aluminium and chrome-plated winch barrels. Specify brand, size, and finish — available for single and double-speed winches from Harken, Lewmar, Antal, and Andersen.' },
      { ref: 3, name: 'Gear Sets & Assemblies',    desc: 'Primary and secondary gear sets, pinions, and spindle shaft assemblies for winch rebuilds. Select your brand and model above to find the correct gear ratio components.' },
      { ref: 4, name: 'Pawls & Pawl Springs',      desc: 'Stainless steel pawls and hardened pawl springs for all winch sizes. Essential service kit components — recommended replacement during every annual winch service.' },
      { ref: 5, name: 'Base Plates & Deck Mounts', desc: 'Winch deck mounting bases and hardware kits. Available in standard and offset configurations for flush or raised deck installation on all major winch brands.' },
    ],
    blocks: [
      { ref: 1, name: 'Swivel & Head Shackles',    desc: 'Top swivel assemblies and head shackle fittings for blocks. Sized by working load and rope diameter — available for Harken, Antal, Ronstan, Lewmar, and Schaefer.' },
      { ref: 2, name: 'Block Housing & Side Plates',desc: 'Side plate and cheek plate assemblies for block rebuilds. Available in aluminium and composite construction for single, double, and triple block configurations.' },
      { ref: 3, name: 'Sheave Replacements',       desc: 'Torlon, nylon, and aluminium sheave wheels for all block sizes. Sized by block model and rope diameter — essential for maintaining low-friction performance.' },
      { ref: 4, name: 'Axle Pins & Fasteners',     desc: 'Stainless steel axle pins, clevis pins, and split pin sets for block assemblies. Direct OEM replacement hardware for Harken, Ronstan, Antal, and other brands.' },
      { ref: 5, name: 'Becket & Tail Fittings',    desc: 'Lower becket assemblies and tail block attachment fittings. Available in fixed and swivel variants — select your block brand and model above for exact compatibility.' },
    ],
    hatches: [
      { ref: 1, name: 'Hatch Lid Replacements',    desc: 'Acrylic and aluminium lid panels for deck hatches — available clear or tinted. Specify your hatch brand, model, and size for a direct-fit replacement lid panel.' },
      { ref: 2, name: 'Seal & Gasket Kits',        desc: 'EPDM compression seals and full gasket replacement kits for all major hatch brands including Lewmar, Bomar, and Goiot. Regular seal replacement prevents water ingress.' },
      { ref: 3, name: 'Hinge Assembly Replacements',desc: 'Stainless steel hinge assemblies and pivot pin kits for deck hatches. Genuine OEM replacements to restore smooth lid operation — match your hatch brand and size.' },
      { ref: 4, name: 'Latch & Handle Mechanisms', desc: 'Spring-loaded latch mechanisms and handle replacements. Available in flush and pull-up handle designs for Lewmar Ocean, Low Profile, and Coastline hatch ranges.' },
      { ref: 5, name: 'Frame & Surround Kits',     desc: 'Deck-mount hatch frames, coaming surrounds, and drain channel assemblies. Select your hatch brand and series above to find the correct frame replacement kit.' },
    ],
    windlasses: [
      { ref: 1, name: 'Chain Wildcats & Gypsies',   desc: 'Windlass chain gypsy and wildcat wheels — the chain-engaging drum that drives your anchor chain. Available for Lewmar, Maxwell, Quick, and Lofrans. Match your chain size and windlass model for correct fit.' },
      { ref: 2, name: 'Motor & Solenoid Kits',      desc: 'Electric motor assemblies, solenoid valves, and contactor units for electric windlasses. Genuine OEM replacement drive components — select your brand and model above for compatibility.' },
      { ref: 3, name: 'Service & Maintenance Kits', desc: 'Complete windlass service kits including seals, gaskets, lubricants, and wear items. Recommended annual replacement to maintain watertight integrity and reliable operation in marine environments.' },
      { ref: 4, name: 'Clutch & Brake Assemblies',  desc: 'Freewheeling clutch levers, friction discs, and brake components for manual override operation. Critical safety parts — allows chain to run free for emergency anchoring.' },
      { ref: 5, name: 'Foot Switches & Controls',   desc: 'Deck-mount foot switches, control panels, and remote handsets for electric windlasses. Waterproof-rated replacements for Lewmar, Maxwell, Quick, and Lofrans control systems.' },
    ],
    portlights: [
      { ref: 1, name: 'Portlight Lenses & Glazing', desc: 'Clear and tinted acrylic or glass lens panels for opening and fixed portlights. Available for Lewmar, Vetus, and GOIOT — specify your portlight model and size for a watertight direct-fit replacement.' },
      { ref: 2, name: 'Hinge & Frame Assemblies',   desc: 'Hinge pin sets and full frame surround kits for opening portlights. Restore smooth operation and weathertight sealing — available in anodised aluminium and stainless steel.' },
      { ref: 3, name: 'Seal & Gasket Kits',         desc: 'EPDM and neoprene compression seals, glazing gaskets, and full seal replacement kits for all major portlight brands. Regular replacement prevents water ingress and cabin moisture damage.' },
      { ref: 4, name: 'Latch & Lock Mechanisms',    desc: 'Stainless steel opening latches, dogs, and locking hardware for marine portlights. Available for Lewmar, Vetus, and GOIOT — match your portlight series and opening size.' },
      { ref: 5, name: 'Screen & Louvre Inserts',    desc: 'Replacement insect screens, louvre inserts, and ventilation panels for opening portlights. Snap-fit or screw-fit designs available for most Lewmar and Vetus portlight models.' },
    ],
    'traveler-cars': [
      { ref: 1, name: 'Traveler Cars & Bodies',     desc: 'Main traveler car bodies with integrated ball bearing races for low-friction mainsheet control. Available in single and double-ended configurations — specify your track width and load rating.' },
      { ref: 2, name: 'Track & Rail Sections',      desc: 'Anodised aluminium traveler track extrusions in standard 1m and 2m sections. T-track, I-track, and top-hat profiles available — select your brand and section profile above.' },
      { ref: 3, name: 'End Controls & Blocks',      desc: 'Traveler control block sets, fairleads, and turning blocks for the track ends. Allows single or double-ended control line purchase — sized by track load and line diameter.' },
      { ref: 4, name: 'End Stops & Caps',           desc: 'Track end stop fittings and endcap sets to retain the traveler car on the track. Available in aluminium and stainless steel — match your track profile for secure retention.' },
      { ref: 5, name: 'Bearing & Slide Kits',       desc: 'Ball bearing replacement kits and low-friction slide inserts for traveler cars. Restore smooth, precise traveler movement — available for all major track and car combinations.' },
    ],
    'bow-thrusters': [
      { ref: 1, name: 'Propellers',                 desc: 'Replacement bow and stern thruster propellers — available in 2-blade, 3-blade, and 6-blade configurations. Sized by tunnel diameter and thruster model. Available for Lewmar TT, Sleipner SP/SE, Vetus BOW, and Quick BTQ series.' },
      { ref: 2, name: 'Gearboxes & Drivetrains',    desc: 'Complete gearbox assemblies and drivetrain components for bow and stern thrusters. Genuine OEM replacement units — select your brand and thruster model above for correct fitment and voltage rating.' },
      { ref: 3, name: 'Tunnels',                    desc: 'GRP and aluminium thruster tunnel tubes for in-hull installation. Available in standard diameters from 125mm to 386mm. Match your thruster model and kgf rating for correct tunnel sizing.' },
      { ref: 4, name: 'Control Panels & Cables',    desc: 'Joystick control panels, remote handsets, and wiring harnesses for electric bow and stern thrusters. Waterproof-rated replacements for Lewmar, Sleipner, Vetus, and Quick control systems.' },
      { ref: 5, name: 'Anodes & Service Parts',     desc: 'Zinc and aluminium sacrificial anodes, seal kits, and service parts for bow thruster maintenance. Includes shear pins, fuses, mounting hardware, and installation kits for all major brands.' },
    ],
  };

  // ─── SUB-CATEGORY KEYWORD RULES (per category, first match wins) ────────────
  var SUBCAT_RULES = {
    furlers: [
      { re: /head swivel|swivel.*assembly|swivel.*top cap|swivel cover|swivel cap/i, label: 'Swivel & Head' },
      { re: /snap shackle|shackle/i,                                                  label: 'Shackles' },
      { re: /drum.*only|drum.*assembly|drum.*cage|drum.*mechanism|drum.*half|drum.*nose|drum.*rotating/i, label: 'Drum Assembly' },
      { re: /drum.*shape.*adapter|drum.*adapter/i,                                    label: 'Drum Adapters' },
      { re: /drum.*guard|drum.*cover|drum.*turnbuckle/i,                              label: 'Drum Covers' },
      { re: /turnbuckle/i,                                                            label: 'Turnbuckle' },
      { re: /bottom extrusion|intermediate extrusion|extrusion.*only|extrusion.*assembly|extrusion.*telescop/i, label: 'Foil & Extrusion' },
      { re: /extrusion.*bushing|extrusion.*connector/i,                               label: 'Foil & Extrusion' },
      { re: /sail feeder|feeder/i,                                                    label: 'Sail Feeder' },
      { re: /fairlead/i,                                                              label: 'Fairleads' },
      { re: /link plate/i,                                                            label: 'Link Plates' },
      { re: /threaded clevis|clevis pin/i,                                            label: 'Clevis Pins' },
      { re: /bushing.*pin|pin.*bushing|bushings.*bolt|bolt.*pin|bushings.*kit/i,      label: 'Pins & Bushings' },
      { re: /bearing.*holder|top.*bearing.*holder|bottom.*bearing.*holder|intermediate.*bearing.*holder/i, label: 'Bearing Holders' },
      { re: /bearing/i,                                                               label: 'Bearings' },
      { re: /hh screw|drum.*screw|sail feeder.*screw|trim cap screw|allen.*screw|cap screw/i, label: 'Screws' },
      { re: /\bscrew/i,                                                               label: 'Screws' },
      { re: /\bnut\b/i,                                                               label: 'Screws' },
      { re: /toggle nylon|toggle socket/i,                                            label: 'Toggle Fittings' },
      { re: /toggle/i,                                                                label: 'Toggle Fittings' },
      { re: /cotter pin/i,                                                            label: 'Cotter Pins' },
      { re: /\bbushing/i,                                                             label: 'Pins & Bushings' },
      { re: /plastic/i,                                                               label: 'Pins & Bushings' },
      { re: /wrapstop/i,                                                              label: 'Accessories' },
    ],
    winches: [
      { re: /motor.*gearbox|gearbox.*motor/i,                                         label: 'Motor & Gearbox' },
      { re: /control.*box|control.*unit/i,                                            label: 'Control Boxes' },
      { re: /circuit.*breaker/i,                                                      label: 'Circuit Breakers' },
      { re: /\bcontactor\b/i,                                                         label: 'Contactors' },
      { re: /\bmotor\b/i,                                                             label: 'Motor & Gearbox' },
      { re: /alumin.*drum|chrome.*drum|\bdrum\b/i,                                    label: 'Drums' },
      { re: /\bpinion\b/i,                                                            label: 'Pinions' },
      { re: /pawl.*spring|spring.*pawl/i,                                             label: 'Pawls & Springs' },
      { re: /\bpawl\b/i,                                                              label: 'Pawls & Springs' },
      { re: /pawl.*carrier|ratchet.*gear|\bratchet\b/i,                               label: 'Ratchet & Carriers' },
      { re: /stripper.*arm|arm.*stripper/i,                                           label: 'Stripper Arms' },
      { re: /stripper.*cover|stripper.*housing/i,                                     label: 'Stripper Covers' },
      { re: /\bgear\b|\bz\d{2}\b/i,                                                   label: 'Gears' },
      { re: /roller.*bearing|\bbearing\b/i,                                           label: 'Bearings' },
      { re: /ptfe|igus|\bbushing\b/i,                                                 label: 'Bushings' },
      { re: /\bspacer\b/i,                                                            label: 'Spacers' },
      { re: /\bwasher\b/i,                                                            label: 'Washers' },
      { re: /top.*cap|\bcap\b/i,                                                      label: 'Caps & Covers' },
      { re: /spindle|shaft/i,                                                         label: 'Spindle & Shaft' },
      { re: /\bhandle\b|\bsocket\b/i,                                                 label: 'Handle & Socket' },
      { re: /red.*line.*ring|line.*ring/i,                                            label: 'Line Rings' },
      { re: /\bpeeler\b/i,                                                            label: 'Peelers' },
      { re: /\bscrew\b|\bnut\b/i,                                                     label: 'Screws & Nuts' },
      { re: /\bpin\b/i,                                                               label: 'Pins' },
      { re: /\bring\b|\bclip\b/i,                                                     label: 'Rings & Clips' },
    ],
    blocks: [
      { re: /sheave|pulley/i,                                                         label: 'Sheaves' },
      { re: /repair.*kit|service.*kit/i,                                              label: 'Repair Kits' },
      { re: /roller.*bearing|\bbearing\b/i,                                           label: 'Bearings' },
      { re: /side.*plate|cheek.*plate/i,                                              label: 'Side Plates' },
      { re: /\bclevis\b|\bpin\b/i,                                                    label: 'Pins & Clevis' },
      { re: /becket/i,                                                                label: 'Beckets' },
      { re: /\bscrew\b|\bnut\b|\bbolt\b/i,                                            label: 'Screws & Bolts' },
      { re: /\bstrap\b/i,                                                             label: 'Straps' },
      { re: /shackle/i,                                                               label: 'Shackles' },
    ],
    hatches: [
      { re: /lid.*only|acrylic.*lid|alumin.*lid|\blid\b/i,                            label: 'Lids' },
      { re: /seal.*kit|service.*kit|repair.*kit/i,                                    label: 'Service Kits' },
      { re: /\bseal\b|gasket|rubber.*seal|epdm/i,                                     label: 'Seals & Gaskets' },
      { re: /hinge|pivot/i,                                                           label: 'Hinges' },
      { re: /latch|handle.*latch|latch.*handle/i,                                     label: 'Latches' },
      { re: /\bhandle\b/i,                                                            label: 'Handles' },
      { re: /frame|surround|coaming/i,                                                label: 'Frames' },
      { re: /\bspring\b/i,                                                            label: 'Springs' },
      { re: /\bscrew\b|\bnut\b|\bbolt\b/i,                                            label: 'Fasteners' },
      { re: /\bpin\b|\bbushing\b/i,                                                   label: 'Pins & Bushings' },
    ],
    windlasses: [
      { re: /gypsy|wildcat|chain.*wheel|chain.*drum/i,                                label: 'Gypsies & Wildcats' },
      { re: /motor.*gearbox|gearbox.*motor|\bmotor\b/i,                               label: 'Motor & Gearbox' },
      { re: /solenoid|contactor/i,                                                    label: 'Solenoids & Contactors' },
      { re: /service.*kit|maintenance.*kit|repair.*kit/i,                             label: 'Service Kits' },
      { re: /\bseal\b|\bgasket\b/i,                                                   label: 'Seals & Gaskets' },
      { re: /clutch|brake|friction/i,                                                 label: 'Clutch & Brake' },
      { re: /foot.*switch|deck.*switch|\bswitch\b/i,                                  label: 'Switches & Controls' },
      { re: /control.*panel|remote|handset/i,                                         label: 'Switches & Controls' },
      { re: /\bbearing\b|\bbushing\b/i,                                               label: 'Bearings & Bushings' },
      { re: /\bscrew\b|\bnut\b|\bbolt\b/i,                                            label: 'Fasteners' },
    ],
    portlights: [
      { re: /lens|glazing|acrylic|glass.*panel/i,                                     label: 'Lenses & Glazing' },
      { re: /hinge|pivot.*pin/i,                                                      label: 'Hinges' },
      { re: /frame|surround|coaming/i,                                                label: 'Frames & Surrounds' },
      { re: /seal.*kit|gasket.*kit|service.*kit/i,                                    label: 'Service Kits' },
      { re: /\bseal\b|\bgasket\b|epdm|neoprene/i,                                    label: 'Seals & Gaskets' },
      { re: /latch|lock|dog\b|handle/i,                                               label: 'Latches & Locks' },
      { re: /screen|louvre|insect|ventilation.*insert/i,                              label: 'Screens & Louvres' },
      { re: /\bscrew\b|\bnut\b|\bbolt\b|\bpin\b/i,                                   label: 'Fasteners' },
    ],
    'traveler-cars': [
      { re: /traveler.*car|car.*body|slider|carriage/i,                               label: 'Traveler Cars' },
      { re: /\btrack\b|\brail\b|extrusion/i,                                          label: 'Track & Rail' },
      { re: /end.*control|control.*block|turning.*block/i,                            label: 'End Controls' },
      { re: /end.*stop|end.*cap|stop.*cap|track.*end/i,                               label: 'End Stops & Caps' },
      { re: /ball.*bearing|\bbearing\b/i,                                             label: 'Bearings' },
      { re: /slide.*kit|friction.*pad|low.*friction/i,                                label: 'Slide Kits' },
      { re: /becket|control.*line|purchase/i,                                         label: 'Control Hardware' },
      { re: /\bscrew\b|\bnut\b|\bbolt\b|\bpin\b/i,                                   label: 'Fasteners' },
    ],
    'bow-thrusters': [
      { re: /gearbox|drivetrain|drive.*train/i,                                       label: 'Gearboxes & Drivetrains' },
      { re: /\bpropeller\b|\bprop\b/i,                                                label: 'Propellers' },
      { re: /\btunnel\b/i,                                                            label: 'Tunnels' },
      { re: /control.*panel|joystick|handset|remote.*control/i,                       label: 'Control Panels' },
      { re: /control.*cable|wiring.*harness|\bcable\b/i,                              label: 'Control Cables' },
      { re: /\banode\b/i,                                                             label: 'Anodes' },
      { re: /\bfuse\b|fuse.*holder/i,                                                 label: 'Fuses & Holders' },
      { re: /installation.*kit|install.*kit|template/i,                               label: 'Installation Kits' },
      { re: /mounting.*hardware|mount.*kit/i,                                         label: 'Mounting Hardware' },
      { re: /adapter|converter/i,                                                     label: 'Adapters & Converters' },
      { re: /shear.*pin|drive.*pin/i,                                                 label: 'Drive & Shear Pins' },
      { re: /service.*kit|seal.*kit|repair.*kit/i,                                    label: 'Service Kits' },
      { re: /\bscrew\b|\bnut\b|\bbolt\b/i,                                            label: 'Fasteners' },
    ],
  };

  // Category-specific label for parts that don't match any SUBCAT_RULE
  var SUBCAT_FALLBACK = {
    furlers:          'Other Furler Parts',
    winches:          'Other Winch Parts',
    blocks:           'Other Block Parts',
    hatches:          'Other Hatch Parts',
    windlasses:       'Other Windlass Parts',
    portlights:       'Other Portlight Parts',
    'traveler-cars':  'Other Traveler Parts',
    'bow-thrusters':  'Other Thruster Parts',
  };

  function groupBySubcategory(parts) {
    var rules   = SUBCAT_RULES[SPC_CATEGORY] || [];
    var groups  = {};
    var DEFAULT = SUBCAT_FALLBACK[SPC_CATEGORY] || 'Other Parts';
    parts.forEach(function (part) {
      var title   = part.name || '';
      var matched = false;
      for (var i = 0; i < rules.length; i++) {
        if (rules[i].re.test(title)) {
          var lbl = rules[i].label;
          if (!groups[lbl]) groups[lbl] = [];
          groups[lbl].push(part);
          matched = true;
          break;
        }
      }
      if (!matched) {
        if (!groups[DEFAULT]) groups[DEFAULT] = [];
        groups[DEFAULT].push(part);
      }
    });
    return groups;
  }

  // ─── HELPERS ─────────────────────────────────────────────────────────────────
  function titleCase(slug) {
    return String(slug || '').split('-').filter(Boolean).map(function (w) {
      var lower = w.toLowerCase();
      var specials = { mkiv: 'MKIV', mkiii: 'MKIII', nc: 'NC', st: 'ST', evo: 'EVO', xt: 'XT', lx: 'LX', fx: 'FX', fs: 'FS' };
      if (specials[lower]) return specials[lower];
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    }).join(' ');
  }

  function labelWithCount(node, slug) {
    var label = (node && node.label) ? node.label : titleCase(slug);
    var count = (node && typeof node._count === 'number') ? node._count : 0;
    return label + ' (' + count + ')';
  }

  function sortByCount(entries) {
    return entries.slice().sort(function (a, b) {
      return ((b[1] && b[1]._count) || 0) - ((a[1] && a[1]._count) || 0);
    });
  }

  function stripHtml(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    return (d.textContent || d.innerText || '').replace(/\s+/g, ' ').trim();
  }

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  // ─── CUSTOM DROPDOWN MODULE ───────────────────────────────────────────────────
  // Tracks current selections so we don't need native <select>.value
  var DD = { brand: '', category: SPC_CATEGORY, series: '', model: '' };
  var ACTIVE_BRAND = 'harken';

  function ddGetBtn(id) {
    var el = document.getElementById(id);
    return el ? el.querySelector('.spc-dd-btn') : null;
  }

  function ddGetPanel(id) {
    var el = document.getElementById(id);
    return el ? el.querySelector('.spc-dd-panel') : null;
  }

  function ddCloseAll() {
    document.querySelectorAll('.spc-dd-panel').forEach(function (p) { p.hidden = true; });
  }

  function ddOpen(id) {
    ddCloseAll();
    var wrap  = document.getElementById(id);
    var btn   = ddGetBtn(id);
    var panel = ddGetPanel(id);
    if (!btn || !panel) return;
    // position panel relative to button in viewport (position:fixed avoids any overflow:hidden clipping)
    var rect = btn.getBoundingClientRect();
    panel.style.top   = (rect.bottom + 2) + 'px';
    panel.style.left  = rect.left + 'px';
    panel.style.width = rect.width + 'px';
    panel.hidden = false;
  }

  function ddHideField(id) {
    var el = document.getElementById(id);
    var wrap = el && el.closest('.spc-filter');
    if (wrap) wrap.style.display = 'none';
  }

  function ddShowField(id) {
    var el = document.getElementById(id);
    var wrap = el && el.closest('.spc-filter');
    if (wrap) wrap.style.display = '';
  }

  function ddReset(id, placeholder) {
    var btn   = ddGetBtn(id);
    var panel = ddGetPanel(id);
    if (btn) {
      btn.textContent = placeholder || '\u2014';
      btn.disabled = true;
      btn.onclick = null;
    }
    if (panel) { panel.innerHTML = ''; panel.hidden = true; }
    var field = id.replace('spc-', '');
    if (field in DD) DD[field] = '';
  }

  function ddPopulate(id, items, placeholder) {
    var btn   = ddGetBtn(id);
    var panel = ddGetPanel(id);
    if (!btn || !panel) return;
    panel.innerHTML = '';
    if (!items || !items.length) { ddReset(id, placeholder); return; }

    items.forEach(function (item) {
      var div = document.createElement('div');
      div.className = 'spc-dd-item';
      div.dataset.value = item.value;
      div.textContent   = item.label;
      panel.appendChild(div);
    });

    btn.textContent = placeholder || '\u2014';
    btn.disabled = false;
    btn.onclick = function (e) {
      e.stopPropagation();
      if (panel.hidden) { ddOpen(id); } else { panel.hidden = true; }
    };
  }

  function ddSelect(id, value, label) {
    var field = id.replace('spc-', '');
    if (field in DD) DD[field] = value;
    var btn   = ddGetBtn(id);
    var panel = ddGetPanel(id);
    if (btn)   btn.textContent = label || value;
    if (panel) {
      panel.hidden = true;
      panel.querySelectorAll('.spc-dd-item').forEach(function (el) {
        el.classList.toggle('spc-dd-item--selected', el.dataset.value === value);
      });
    }
  }

  // ─── DROPDOWN POPULATION ─────────────────────────────────────────────────────
  function populateBrands(hierarchy) {
    // Legacy hook left for backwards compatibility (brand is driven by top tabs).
    return [];
  }

  function populateSeries(brandSlug) {
    ddReset('spc-series', '\u2014');
    ddReset('spc-model',  '\u2014');
    ddShowField('spc-series'); // restore visibility in case it was hidden
    if (!brandSlug || !S.hierarchy) return;

    var catNode   = S.hierarchy[SPC_CATEGORY];
    var brandNode = catNode && catNode.brands[brandSlug];
    if (!brandNode) return;

    var entries = sortByCount(Object.entries(brandNode.series || {}).filter(seriesEntryIsSelectable));
    if (!entries.length) return;

    // If there is only one series, skip the Series step: auto-select silently and hide the row.
    if (entries.length === 1) {
      var e0 = entries[0];
      DD.series = e0[0];
      ddHideField('spc-series');
      populateModels(brandSlug, e0[0]);
      return;
    }

    // Multiple series — show the dropdown normally
    ddPopulate('spc-series', entries.map(function (e) {
      return { value: e[0], label: labelWithCount(e[1], e[0]) };
    }), '\u2014');
  }

  function populateModels(brandSlug, seriesSlug) {
    ddReset('spc-model', '\u2014');
    if (!brandSlug || !seriesSlug || !S.hierarchy) return;

    var catNode    = S.hierarchy[SPC_CATEGORY];
    var seriesNode = catNode && catNode.brands[brandSlug] && catNode.brands[brandSlug].series[seriesSlug];
    if (!seriesNode) return;

    var entries = sortByCount(Object.entries(seriesNode.models || {}).filter(modelEntryIsSelectable));
    if (!entries.length) return;

    ddPopulate('spc-model', entries.map(function (e) {
      return { value: e[0], label: labelWithCount(e[1], e[0]) };
    }), '\u2014');
  }

  // ─── PRODUCT LOADING ─────────────────────────────────────────────────────────
  function loadCollectionParts(collectionHandle, assemblyName, fallbackHandles) {
    var bar  = document.getElementById('spc-parts-bar');
    var area = document.getElementById('spc-diagram-area');
    if (bar)  bar.innerHTML  = '<span class="spc-parts-label">Loading\u2026</span>';
    if (area) area.innerHTML = '<div class="spc-loading"><div class="spc-spinner"></div><span>Loading parts\u2026</span></div>';
    hideDetail();

    function fallbackToHandlesOrDemo() {
      if (fallbackHandles && fallbackHandles.length) {
        loadProductHandlesParts(fallbackHandles, assemblyName);
      } else {
        setDemoState();
      }
    }

    fetch('/collections/' + collectionHandle + '/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('products'); return r.json(); })
      .then(function (data) {
        var products = data.products || [];
        if (!products.length) { fallbackToHandlesOrDemo(); return; }

        var parts = products.map(function (product, i) {
          var variant   = product.variants && product.variants[0];
          var price     = variant ? parseFloat(variant.price) : null;
          var compareAt = variant && variant.compare_at_price ? parseFloat(variant.compare_at_price) : null;
          var sku       = (variant && variant.sku) ? variant.sku : product.handle.toUpperCase().replace(/-/g, '');
          var image     = (product.images && product.images[0]) ? product.images[0].src : null;
          return {
            ref:        i + 1,
            name:       product.title,
            desc:       stripHtml(product.body_html || '').substring(0, 160),
            productUrl: '/products/' + product.handle,
            image:      image,
            codes: [{
              pn:        sku,
              price:     price,
              was:       (compareAt && compareAt > price) ? compareAt : null,
              variantId: variant ? variant.id : null,
              handle:    product.handle,
            }],
          };
        });

        setAssembly(parts, assemblyName, true);
      })
      .catch(function () { fallbackToHandlesOrDemo(); });
  }

  // ─── LOAD BY PRODUCT HANDLES (blocks / models without a collection) ───────────
  function loadProductHandlesParts(handles, assemblyName) {
    var bar  = document.getElementById('spc-parts-bar');
    var area = document.getElementById('spc-diagram-area');
    if (bar)  bar.innerHTML  = '<span class="spc-parts-label">Loading\u2026</span>';
    if (area) area.innerHTML = '<div class="spc-loading"><div class="spc-spinner"></div><span>Loading parts\u2026</span></div>';
    hideDetail();

    if (!handles || !handles.length) { setDemoState(); return; }

    Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.json', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }))
      .then(function (results) {
        var parts = [];
        results.forEach(function (data) {
          if (!data || !data.product) return;
          var product   = data.product;
          var variant   = product.variants && product.variants[0];
          var price     = variant ? parseFloat(variant.price) : null;
          var compareAt = variant && variant.compare_at_price ? parseFloat(variant.compare_at_price) : null;
          var sku       = (variant && variant.sku) ? variant.sku : product.handle.toUpperCase().replace(/-/g, '');
          var image     = (product.images && product.images[0]) ? product.images[0].src : null;
          parts.push({
            ref:        parts.length + 1,
            name:       product.title,
            desc:       stripHtml(product.body_html || '').substring(0, 160),
            productUrl: '/products/' + product.handle,
            image:      image,
            codes: [{
              pn:        sku,
              price:     price,
              was:       (compareAt && compareAt > price) ? compareAt : null,
              variantId: variant ? variant.id : null,
              handle:    product.handle,
            }],
          });
        });
        if (!parts.length) { setDemoState(); return; }
        setAssembly(parts, assemblyName, true);
      })
      .catch(function () { setDemoState(); });
  }

  // ─── ASSEMBLY STATE ───────────────────────────────────────────────────────────
  function setAssembly(parts, name, isLive) {
    S.activePart   = null;
    S.isLive       = !!isLive;
    S.currentParts = parts;
    S.assemblyName = name || 'Assembly';
    S.activeSubcat = null;
    S.subcatGroups = {};

    if (isLive && parts.length) {
      S.subcatGroups = groupBySubcategory(parts);
      var keys = Object.keys(S.subcatGroups);
      S.activeSubcat = keys.length ? keys[0] : null;
    }

    hideDetail();
    renderPartsBar();
    renderDiagram();
    updateSystemBtn(S.assemblyName, isLive);
  }

  // Sets diagram to demo state WITHOUT touching the dropdowns
  function setDemoState() {
    var catLabels = { furlers: 'Furler', winches: 'Winch', blocks: 'Block', hatches: 'Hatch', windlasses: 'Windlass', portlights: 'Portlight', 'traveler-cars': 'Traveler Car', 'bow-thrusters': 'Bow Thruster' };
    var catLabel  = catLabels[SPC_CATEGORY] || titleCase(SPC_CATEGORY);
    var demoParts = DEMO_PARTS[SPC_CATEGORY] || DEMO_PARTS.furlers;
    setAssembly(demoParts, catLabel + ' assembly (demo)', false);
  }

  // Full reset: clears dropdowns + shows demo (tab switch / system button)
  function resetToDemo() {
    DD.brand = ''; DD.series = ''; DD.model = '';
    ACTIVE_BRAND = '';
    ddReset('spc-series', '\u2014');
    ddReset('spc-model',  '\u2014');
    ddReset('spc-component', '\u2014');
    setDemoState();
  }

  // ─── CATEGORY SWITCHING ───────────────────────────────────────────────────────
  var VALID_CATS = ['furlers', 'winches', 'blocks', 'hatches', 'windlasses', 'portlights', 'traveler-cars', 'bow-thrusters'];
  var CAT_LABELS = {
    'furlers': 'Furlers', 'winches': 'Winches', 'blocks': 'Blocks',
    'hatches': 'Hatches', 'windlasses': 'Windlasses', 'portlights': 'Portlights',
    'traveler-cars': 'Traveler Cars', 'bow-thrusters': 'Bow Thrusters',
  };

  function modelNodeIsNavigable(m) {
    return !!(m && (m.collectionHandle || (m.productHandles && m.productHandles.length > 0)));
  }

  function seriesNodeHasNavigableModel(seriesNode) {
    if (!seriesNode || !seriesNode.models) return false;
    return Object.keys(seriesNode.models).some(function (slug) {
      return modelNodeIsNavigable(seriesNode.models[slug]);
    });
  }

  function seriesEntryIsSelectable(e) {
    var sn = e[1];
    if (!sn) return false;
    if (sn._count > 0) return true;
    if (seriesNodeHasNavigableModel(sn)) return true;
    var keys = sn.models && Object.keys(sn.models);
    return !!(keys && keys.length);
  }

  function modelEntryIsSelectable(e) {
    var m = e[1];
    if (!m || typeof m !== 'object') return false;
    if (m._count > 0) return true;
    if (modelNodeIsNavigable(m)) return true;
    if (m.label != null && String(m.label).trim().length > 0) return true;
    return false;
  }

  function parseConfiguratorQuery() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      return {
        category: params.get('category') || '',
        brand: params.get('brand') || '',
        series: params.get('series') || '',
        model: params.get('model') || ''
      };
    } catch (err) {
      return { category: '', brand: '', series: '', model: '' };
    }
  }

  /**
   * Deep-link series/model from query string (?series=&model=). Resolves single-series brands when series is omitted but model is present.
   */
  function applySeriesModelFromUrl(q) {
    if (!q || !S.hierarchy || !DD.brand) return;

    var catNode = S.hierarchy[SPC_CATEGORY];
    var brandNode = catNode && catNode.brands[DD.brand];
    if (!brandNode) return;

    var seriesEntriesAll = sortByCount(Object.entries(brandNode.series || {}).filter(seriesEntryIsSelectable));

    var seriesSlug = q.series || '';
    if (!seriesSlug && q.model && seriesEntriesAll.length === 1) {
      seriesSlug = seriesEntriesAll[0][0];
    }
    if (!seriesSlug) return;

    var seriesNode = brandNode.series[seriesSlug];
    if (!seriesNode) return;

    DD.series = seriesSlug;

    var seriesLabel = labelWithCount(seriesNode, seriesSlug);

    if (seriesEntriesAll.length === 1 && seriesEntriesAll[0][0] === seriesSlug) {
      ddHideField('spc-series');
      populateModels(DD.brand, seriesSlug);
    } else {
      ddShowField('spc-series');
      ddPopulate('spc-series', seriesEntriesAll.map(function (e) {
        return { value: e[0], label: labelWithCount(e[1], e[0]) };
      }), '\u2014');
      ddSelect('spc-series', seriesSlug, seriesLabel);
      populateModels(DD.brand, seriesSlug);
    }

    if (!q.model) {
      autoLoadSingleModel(DD.brand, seriesSlug);
      return;
    }

    var modelNode = seriesNode.models[q.model];
    if (!modelNode || !modelEntryIsSelectable([q.model, modelNode])) return;

    DD.model = q.model;
    ddSelect('spc-model', q.model, labelWithCount(modelNode, q.model));

    var brandLabel = (brandNode.label || titleCase(DD.brand));
    var seriesLbl = (seriesNode.label || titleCase(seriesSlug));
    var modelLbl = (modelNode.label || titleCase(q.model));
    var assemblyName = brandLabel + ' ' + seriesLbl + ' ' + modelLbl;

    if (modelNode.collectionHandle) {
      loadCollectionParts(modelNode.collectionHandle, assemblyName, modelNode.productHandles || []);
    } else if (modelNode.productHandles && modelNode.productHandles.length) {
      loadProductHandlesParts(modelNode.productHandles, assemblyName);
    } else {
      setDemoState();
    }
  }

  function setActiveBrandTab(brandSlug) {
    document.querySelectorAll('.spc-tab[data-brand]').forEach(function (t) {
      t.classList.toggle('spc-tab--active', t.dataset.brand === brandSlug);
    });
  }

  function findFirstBrandFromNav() {
    var first = document.querySelector('.spc-tab[data-brand]');
    return first ? first.dataset.brand : '';
  }

  function brandDisplayLabel(brandSlug) {
    var tab = document.querySelector('.spc-tab[data-brand="' + brandSlug + '"]');
    if (tab && tab.textContent) return tab.textContent.trim();
    return titleCase(brandSlug);
  }

  function getCategoriesForBrand(hierarchy, brandSlug) {
    return VALID_CATS
      .map(function (cat) {
        var catNode = hierarchy && hierarchy[cat];
        var brandNode = catNode && catNode.brands && catNode.brands[brandSlug];
        var count = (brandNode && brandNode._count) || 0;
        return [cat, count];
      })
      .filter(function (entry) {
        return entry[1] > 0;
      });
  }

  function setScopedEmptyState(messageHtml) {
    S.isLive = false;
    S.currentParts = [];
    S.subcatGroups = {};
    S.activeSubcat = null;
    hideDetail();
    ddReset('spc-series', '—');
    ddReset('spc-model',  '—');
    ddReset('spc-component', '—');
    ddShowField('spc-series');
    var area = document.getElementById('spc-diagram-area');
    if (area) {
      area.innerHTML =
        '<div class="spc-coming-soon" style="padding:48px 20px;text-align:center;color:#778;font-size:13px">' +
          (messageHtml || 'No parts available for this selection.') +
        '</div>';
    }
  }

  function switchCategory(cat) {
    SPC_CATEGORY = cat;
    DD.category = cat;
    DD.series = '';
    DD.model = '';
    ddReset('spc-series', '\u2014');
    ddReset('spc-model',  '\u2014');
    ddReset('spc-component', '\u2014');
    ddShowField('spc-series');

    if (VALID_CATS.indexOf(cat) === -1 || !S.hierarchy || !S.hierarchy[cat]) {
      setScopedEmptyState('<strong>' + esc(titleCase(cat)) + '</strong> spare parts \u2014 coming soon.');
      return;
    }

    var brandSlug = ACTIVE_BRAND || DD.brand || findFirstBrandFromNav();
    if (!brandSlug) {
      setScopedEmptyState('Select a brand to load categories.');
      return;
    }
    selectBrandFromNav(brandSlug, true);
  }

  // ─── BRAND TOP-NAV SELECTION ──────────────────────────────────────────────────
  function selectBrandFromNav(brandSlug, silentNav) {
    if (!brandSlug) return;
    ACTIVE_BRAND = brandSlug;
    DD.brand = brandSlug;
    setActiveBrandTab(brandSlug);

    if (!S.hierarchy) { setDemoState(); return; }
    var availableCats = populateCategories(S.hierarchy, brandSlug);
    if (!availableCats.length) {
      setScopedEmptyState('No categories available for <strong>' + esc(brandDisplayLabel(brandSlug)) + '</strong>.');
      return;
    }

    var catNode   = S.hierarchy[SPC_CATEGORY];
    var brandNode = catNode && catNode.brands && catNode.brands[brandSlug];

    if (!brandNode || !brandNode._count) {
      var categoryLabel = CAT_LABELS[SPC_CATEGORY] || titleCase(SPC_CATEGORY);
      setScopedEmptyState('No ' + esc(brandDisplayLabel(brandSlug)) + ' parts in <strong>' + esc(categoryLabel) + '</strong>.');
      return;
    }

    // Cascade: populate Series → auto-select if single → populate Models → auto-load if single
    ddReset('spc-series', '\u2014');
    ddReset('spc-model',  '\u2014');
    ddReset('spc-component', '\u2014');
    ddShowField('spc-series');

    var seriesEntries = sortByCount(Object.entries(brandNode.series || {}).filter(seriesEntryIsSelectable));

    if (!seriesEntries.length) {
      setScopedEmptyState('No series available for <strong>' + esc(brandDisplayLabel(brandSlug)) + '</strong> in this category.');
      return;
    }

    if (seriesEntries.length === 1) {
      DD.series = seriesEntries[0][0];
      ddHideField('spc-series');
      populateModels(brandSlug, DD.series);
      // Auto-load if single model
      autoLoadSingleModel(brandSlug, DD.series);
    } else {
      ddPopulate('spc-series', seriesEntries.map(function (e) {
        return { value: e[0], label: labelWithCount(e[1], e[0]) };
      }), '\u2014');
      setDemoState();
    }
  }

  // Auto-selects + loads parts if a brand/series has exactly one model
  function autoLoadSingleModel(brandSlug, seriesSlug) {
    if (!S.hierarchy) { setDemoState(); return; }
    var catNode    = S.hierarchy[SPC_CATEGORY];
    var seriesNode = catNode && catNode.brands[brandSlug] && catNode.brands[brandSlug].series[seriesSlug];
    if (!seriesNode) { setDemoState(); return; }

    var modelEntries = sortByCount(Object.entries(seriesNode.models || {}).filter(modelEntryIsSelectable));

    if (modelEntries.length === 1) {
      var modelSlug  = modelEntries[0][0];
      var modelNode  = modelEntries[0][1];
      var assemblyName = (brandNode_label(brandSlug) + ' ' + (seriesNode.label || titleCase(seriesSlug)) + ' ' + (modelNode.label || titleCase(modelSlug))).trim();
      ddSelect('spc-model', modelSlug, labelWithCount(modelNode, modelSlug));
      DD.model = modelSlug;
      if (modelNode.collectionHandle) {
        loadCollectionParts(modelNode.collectionHandle, assemblyName, modelNode.productHandles || []);
      } else if (modelNode.productHandles && modelNode.productHandles.length) {
        loadProductHandlesParts(modelNode.productHandles, assemblyName);
      } else {
        setDemoState();
      }
    } else {
      populateModels(brandSlug, seriesSlug);
      setDemoState();
    }
  }

  function brandNode_label(brandSlug) {
    var catNode   = S.hierarchy && S.hierarchy[SPC_CATEGORY];
    var brandNode = catNode && catNode.brands && catNode.brands[brandSlug];
    return (brandNode && brandNode.label) ? brandNode.label : titleCase(brandSlug);
  }

  // ─── CATEGORY DROPDOWN POPULATION ────────────────────────────────────────────
  function populateCategories(hierarchy, brandSlug) {
    var scopedBrand = brandSlug || ACTIVE_BRAND || DD.brand || findFirstBrandFromNav();
    var catEntries = getCategoriesForBrand(hierarchy, scopedBrand);
    if (!catEntries.length) {
      ddReset('spc-category', 'No categories available');
      DD.category = '';
      return [];
    }

    if (!catEntries.some(function (entry) { return entry[0] === SPC_CATEGORY; })) {
      SPC_CATEGORY = catEntries[0][0];
    }

    var items = catEntries.map(function (entry) {
      var cat = entry[0];
      var count = entry[1];
      return { value: cat, label: CAT_LABELS[cat] + ' (' + count + ')' };
    });

    ddPopulate('spc-category', items, 'Equipment type\u2026');
    var selectedItem = items.filter(function (item) { return item.value === SPC_CATEGORY; })[0];
    ddSelect('spc-category', SPC_CATEGORY, selectedItem ? selectedItem.label : (CAT_LABELS[SPC_CATEGORY] || titleCase(SPC_CATEGORY)));
    DD.category = SPC_CATEGORY;
    return catEntries;
  }

  // ─── SYSTEM BUTTON (no-op — systems section removed) ─────────────────────────
  function updateSystemBtn(label, isLive) { /* systems section removed */ }

  // ─── PARTS BAR → COMPONENTS DROPDOWN ────────────────────────────────────────
  function renderPartsBar() {
    if (S.isLive) {
      var keys = Object.keys(S.subcatGroups);
      if (!keys.length) { ddReset('spc-component', '\u2014'); return; }
      var items = keys.map(function (k) {
        return { value: k, label: k + ' (' + S.subcatGroups[k].length + ')' };
      });
      ddPopulate('spc-component', items, 'Select component\u2026');
      if (S.activeSubcat && S.subcatGroups[S.activeSubcat]) {
        ddSelect('spc-component', S.activeSubcat,
          S.activeSubcat + ' (' + S.subcatGroups[S.activeSubcat].length + ')');
      }
    } else {
      var items = S.currentParts.map(function (p, i) {
        return { value: String(i), label: p.ref + ' \u2014 ' + p.name };
      });
      if (!items.length) { ddReset('spc-component', '\u2014'); return; }
      ddPopulate('spc-component', items, 'Select component\u2026');
      if (S.activePart !== null && items[S.activePart]) {
        ddSelect('spc-component', String(S.activePart), items[S.activePart].label);
      }
    }
  }

  function selectSubcat(key) {
    S.activeSubcat = key;
    var count = S.subcatGroups[key] ? S.subcatGroups[key].length : 0;
    ddSelect('spc-component', key, key + ' (' + count + ')');
    renderDiagram();
  }

  // ─── DIAGRAM DISPATCH ────────────────────────────────────────────────────────
  function renderDiagram() {
    var area = document.getElementById('spc-diagram-area');
    if (!area) return;
    if (S.isLive) {
      if (S.activeSubcat && S.subcatGroups[S.activeSubcat]) {
        renderCatalogTable(S.subcatGroups[S.activeSubcat], area);
      } else {
        area.innerHTML = '<div class="spc-diagram-hint">Select a sub-assembly above to view parts.</div>';
      }
    } else {
      renderDemoSvg(S.currentParts, area);
    }
  }

  // ─── CATALOG TABLE (live mode) ───────────────────────────────────────────────
  function renderCatalogTable(subcatParts, area) {
    if (!subcatParts || !subcatParts.length) {
      area.innerHTML = '<div class="spc-diagram-hint">No parts in this sub-assembly.</div>';
      return;
    }

    var assemblyImg = null;
    for (var i = 0; i < subcatParts.length; i++) {
      if (subcatParts[i].image) { assemblyImg = subcatParts[i].image; break; }
    }

    var html = '<div class="spc-catalog">';

    html += '<div class="spc-catalog-img">';
    if (assemblyImg) {
      html += '<img src="' + esc(assemblyImg) + '" alt="' + esc(S.activeSubcat || '') + '" loading="lazy">';
    } else {
      html += '<div class="spc-catalog-img-empty">' +
        '<svg viewBox="0 0 64 64" fill="none" width="44" height="44"><circle cx="32" cy="32" r="22" stroke="#ccd0d8" stroke-width="1.5"/><circle cx="32" cy="32" r="9" stroke="#ccd0d8" stroke-width="1.5"/><line x1="32" y1="10" x2="32" y2="54" stroke="#ccd0d8" stroke-width="1" stroke-dasharray="3 3"/><line x1="10" y1="32" x2="54" y2="32" stroke="#ccd0d8" stroke-width="1" stroke-dasharray="3 3"/></svg>' +
        '<span>No image</span></div>';
    }
    if (S.activeSubcat) html += '<p class="spc-catalog-img-label">' + esc(S.activeSubcat) + '</p>';
    html += '</div>';

    html += '<div class="spc-catalog-table-wrap">';
    html += '<table class="spc-catalog-table">';
    html += '<thead><tr>';
    html += '<th class="spc-th spc-th-ref">Ref.</th>';
    html += '<th class="spc-th spc-th-pn">Part N\u00b0</th>';
    html += '<th class="spc-th spc-th-desc">Description</th>';
    html += '<th class="spc-th spc-th-price">Price</th>';
    html += '<th class="spc-th spc-th-action"></th>';
    html += '</tr></thead><tbody>';

    subcatParts.forEach(function (part, idx) {
      var code = part.codes && part.codes[0];
      var pn   = code ? code.pn : '\u2014';
      var priceHtml = '';
      if (code && code.price !== null && code.price !== undefined) {
        priceHtml = (code.was ? '<s class="spc-was">$' + code.was.toFixed(2) + '</s> ' : '') +
          '<strong>$' + code.price.toFixed(2) + '</strong>';
      } else {
        priceHtml = '\u2014';
      }

      var atcHtml = '';
      if (code && code.variantId) {
        atcHtml = '<button class="spc-code-atc" onclick="window.__spcAddToCart(' + code.variantId + ', this)">Add</button>';
      } else if (code && code.handle) {
        atcHtml = '<a href="/products/' + esc(code.handle) + '" class="spc-code-atc spc-code-atc--view" style="text-decoration:none">View</a>';
      }

      html += '<tr class="spc-catalog-row">';
      html += '<td class="spc-td spc-td-ref"><span class="spc-catalog-ref-badge">' + (idx + 1) + '</span></td>';
      html += '<td class="spc-td spc-td-pn"><a href="' + esc(part.productUrl || '#') + '" class="spc-catalog-pn">' + esc(pn) + '</a></td>';
      html += '<td class="spc-td spc-td-desc">' + esc(part.name) + '</td>';
      html += '<td class="spc-td spc-td-price">' + priceHtml + '</td>';
      html += '<td class="spc-td spc-td-action">' + atcHtml + '</td>';
      html += '</tr>';
    });

    html += '</tbody></table></div></div>';
    area.innerHTML = html;
  }

  // ─── DEMO SVG DISPATCHER ──────────────────────────────────────────────────────
  function renderDemoSvg(parts, area) {
    if (SPC_CATEGORY === 'winches')       { renderWinchSvg(parts, area);       return; }
    if (SPC_CATEGORY === 'blocks')        { renderBlockSvg(parts, area);       return; }
    if (SPC_CATEGORY === 'hatches')       { renderHatchSvg(parts, area);       return; }
    if (SPC_CATEGORY === 'windlasses')    { renderWindlassSvg(parts, area);    return; }
    if (SPC_CATEGORY === 'portlights')    { renderPortlightSvg(parts, area);   return; }
    if (SPC_CATEGORY === 'traveler-cars') { renderTravelerCarSvg(parts, area); return; }
    if (SPC_CATEGORY === 'bow-thrusters') { renderBowThrusterSvg(parts, area); return; }
    renderFurlerSvg(parts, area);
  }

  // ─── WINDLASS DIAGRAM IMAGE ───────────────────────────────────────────────────
  function renderWindlassSvg(parts, area) {
    var imgUrl = window.__spcWindlassDiagram || '';
    if (!imgUrl) {
      area.innerHTML = '<div class="spc-diagram-hint" style="padding-top:60px">Diagram coming soon</div>';
      return;
    }
    area.innerHTML =
      '<div style="text-align:center;padding:8px 0"><div class="spc-diagram-img-wrap">' +
        '<img src="' + imgUrl + '" alt="Windlass parts diagram" style="width:100%;max-width:560px;display:block;margin:0 auto;border-radius:6px"/>' +
      '</div></div>' +
      '';
  }

  // ─── PORTLIGHT DIAGRAM IMAGE ──────────────────────────────────────────────────
  function renderPortlightSvg(parts, area) {
    var imgUrl = window.__spcPortlightDiagram || '';
    if (!imgUrl) {
      area.innerHTML = '<div class="spc-diagram-hint" style="padding-top:60px">Diagram coming soon</div>';
      return;
    }
    area.innerHTML =
      '<div style="text-align:center;padding:8px 0"><div class="spc-diagram-img-wrap">' +
        '<img src="' + imgUrl + '" alt="Portlight parts diagram" style="width:100%;max-width:560px;display:block;margin:0 auto;border-radius:6px"/>' +
      '</div></div>' +
      '';
  }

  // ─── TRAVELER CAR DIAGRAM IMAGE ───────────────────────────────────────────────
  function renderTravelerCarSvg(parts, area) {
    var imgUrl = window.__spcTravelerDiagram || '';
    if (!imgUrl) {
      area.innerHTML = '<div class="spc-diagram-hint" style="padding-top:60px">Diagram coming soon</div>';
      return;
    }
    area.innerHTML =
      '<div style="text-align:center;padding:8px 0"><div class="spc-diagram-img-wrap">' +
        '<img src="' + imgUrl + '" alt="Traveler car parts diagram" style="width:100%;max-width:560px;display:block;margin:0 auto;border-radius:6px"/>' +
      '</div></div>' +
      '';
  }

  // ─── BOW THRUSTER DIAGRAM IMAGE ──────────────────────────────────────────────
  function renderBowThrusterSvg(parts, area) {
    var imgUrl = window.__spcBowThrusterDiagram || '';
    if (!imgUrl) {
      area.innerHTML = '<div class="spc-diagram-hint" style="padding-top:60px">Diagram coming soon</div>';
      return;
    }
    area.innerHTML =
      '<div style="text-align:center;padding:8px 0"><div class="spc-diagram-img-wrap">' +
        '<img src="' + imgUrl + '" alt="Bow thruster parts diagram" style="width:100%;max-width:560px;display:block;margin:0 auto;border-radius:6px"/>' +
      '</div></div>' +
      '';
  }

  // ─── FURLER DIAGRAM IMAGE ────────────────────────────────────────────────────
  function renderFurlerSvg(parts, area) {
    var imgUrl = 'https://cdn.shopify.com/s/files/1/0879/4908/2930/files/Furler_DIagram2.png?v=1776432417';
    area.innerHTML =
      '<div style="text-align:center;padding:8px 0">' +
        '<div class="spc-diagram-img-wrap">' +
        '<img src="' + imgUrl + '" alt="Furler parts diagram" ' +
          'style="width:100%;max-width:560px;display:block;margin:0 auto;border-radius:6px"/>' +
        '</div>' +
      '</div>' +
      '';
    return;
    var svg = '<svg viewBox="0 0 460 520" style="display:none">';

    svg += '<defs>';
    // Anodised black
    svg += '<linearGradient id="fAnod" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#333"/><stop offset="50%" stop-color="#111"/><stop offset="100%" stop-color="#222"/></linearGradient>';
    // Stainless steel
    svg += '<linearGradient id="fSteel" x1="0" y1="0" x2="1" y2="0.3"><stop offset="0%" stop-color="#e0e0e0"/><stop offset="50%" stop-color="#b0b0b0"/><stop offset="100%" stop-color="#909090"/></linearGradient>';
    // Bronze / gold
    svg += '<linearGradient id="fGold" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#d4af37"/><stop offset="50%" stop-color="#aa8a2e"/><stop offset="100%" stop-color="#8a6d23"/></linearGradient>';
    // Cross-hatch for cut surfaces
    svg += '<pattern id="hatch" width="4" height="4" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><line x1="0" y1="0" x2="0" y2="4" stroke="#666" stroke-width="0.5"/></pattern>';
    svg += '</defs>';

    // Centre axis line
    svg += '<line x1="260" y1="20" x2="260" y2="480" stroke="#ccc" stroke-width="0.5" stroke-dasharray="10,5,2,5"/>';

    // ── Part 1: Top Swivel (with cutaway bearings) ────────────────────────────
    var a1 = ap === 0, o1 = (ap !== null && !a1) ? '0.2' : '1';
    svg += '<g style="cursor:pointer;opacity:' + o1 + '" onclick="window.__spcToggle(0)">';
    if (a1) svg += '<rect x="225" y="45" width="70" height="85" rx="5" fill="none" stroke="#2b9fca" stroke-width="1.5" stroke-dasharray="4,2"/>';
    svg += '<path d="M250 50 Q250 30 260 30 Q270 30 270 50 L270 80 L250 80 Z" fill="url(#fSteel)" stroke="#333"/>';
    svg += '<rect x="245" y="80" width="30" height="25" fill="url(#fSteel)" stroke="#333"/>';
    svg += '<circle cx="253" cy="92" r="2" fill="url(#fGold)"/>';
    svg += '<circle cx="260" cy="92" r="2" fill="url(#fGold)"/>';
    svg += '<circle cx="267" cy="92" r="2" fill="url(#fGold)"/>';
    svg += '<circle cx="310" cy="100" r="10" fill="' + (a1 ? '#2b9fca' : '#7a8494') + '"/>';
    svg += '<text x="310" y="100" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="10" font-weight="700" font-family="sans-serif">1</text>';
    svg += '</g>';

    // ── Part 2: Foil Extrusion (with profile detail) ──────────────────────────
    var a2 = ap === 1, o2 = (ap !== null && !a2) ? '0.2' : '1';
    svg += '<g style="cursor:pointer;opacity:' + o2 + '" onclick="window.__spcToggle(1)">';
    svg += '<rect x="252" y="125" width="16" height="80" fill="url(#fSteel)" stroke="#333"/>';
    svg += '<line x1="260" y1="125" x2="260" y2="205" stroke="rgba(0,0,0,0.2)" stroke-width="1"/>';
    svg += '<path d="M180 130 L220 130 L225 180 L185 180 Z" fill="url(#hatch)" stroke="#333" stroke-width="0.5"/>';
    svg += '<path d="M190 140 L210 140 L210 170 L190 170 Z" fill="#fff" stroke="#333"/>';
    svg += '<line x1="220" y1="155" x2="252" y2="155" stroke="#999" stroke-width="0.5" stroke-dasharray="2,2"/>';
    svg += '<circle cx="310" cy="165" r="10" fill="' + (a2 ? '#2b9fca' : '#7a8494') + '"/>';
    svg += '<text x="310" y="165" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="10" font-weight="700" font-family="sans-serif">2</text>';
    svg += '</g>';

    // ── Part 3: Drum Assembly (cutaway) ───────────────────────────────────────
    var a3 = ap === 2, o3 = (ap !== null && !a3) ? '0.2' : '1';
    svg += '<g style="cursor:pointer;opacity:' + o3 + '" onclick="window.__spcToggle(2)">';
    if (a3) svg += '<rect x="215" y="215" width="90" height="50" rx="5" fill="none" stroke="#2b9fca" stroke-width="1.5" stroke-dasharray="4,2"/>';
    svg += '<path d="M220 220 H300 V260 H220 Z" fill="url(#fAnod)" stroke="#000"/>';
    svg += '<path d="M275 230 L290 230 L290 250 L275 250 Z" fill="url(#hatch)" stroke="#000"/>';
    svg += '<circle cx="330" cy="240" r="10" fill="' + (a3 ? '#2b9fca' : '#7a8494') + '"/>';
    svg += '<text x="330" y="240" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="10" font-weight="700" font-family="sans-serif">3</text>';
    svg += '</g>';

    // ── Part 4: Bearing Unit (isometric ring with ball bearings) ─────────────
    var a4 = ap === 3, o4 = (ap !== null && !a4) ? '0.2' : '1';
    svg += '<g style="cursor:pointer;opacity:' + o4 + '" onclick="window.__spcToggle(3)">';
    svg += '<ellipse cx="260" cy="285" rx="40" ry="12" fill="none" stroke="#333" stroke-width="2"/>';
    svg += '<ellipse cx="260" cy="285" rx="30" ry="8" fill="none" stroke="#333" stroke-width="1"/>';
    var bearingAngles = [0, 45, 90, 135, 180, 225, 270, 315];
    for (var bi = 0; bi < bearingAngles.length; bi++) {
      var bRad = bearingAngles[bi] * Math.PI / 180;
      svg += '<circle cx="' + (260 + Math.cos(bRad) * 35) + '" cy="' + (285 + Math.sin(bRad) * 10) + '" r="2.5" fill="url(#fGold)" stroke="#666" stroke-width="0.3"/>';
    }
    svg += '<circle cx="330" cy="285" r="10" fill="' + (a4 ? '#2b9fca' : '#7a8494') + '"/>';
    svg += '<text x="330" y="285" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="10" font-weight="700" font-family="sans-serif">4</text>';
    svg += '</g>';

    // ── Part 5: Toggle Assembly ───────────────────────────────────────────────
    var a5 = ap === 4, o5 = (ap !== null && !a5) ? '0.2' : '1';
    svg += '<g style="cursor:pointer;opacity:' + o5 + '" onclick="window.__spcToggle(4)">';
    svg += '<rect x="250" y="320" width="20" height="40" rx="2" fill="url(#fSteel)" stroke="#333"/>';
    svg += '<circle cx="260" cy="330" r="4" fill="#666"/>';
    svg += '<path d="M245 360 L275 360 L260 390 Z" fill="url(#fSteel)" stroke="#333"/>';
    svg += '<circle cx="310" cy="360" r="10" fill="' + (a5 ? '#2b9fca' : '#7a8494') + '"/>';
    svg += '<text x="310" y="360" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="10" font-weight="700" font-family="sans-serif">5</text>';
    svg += '</g>';

    svg += '</svg>';
    area.innerHTML = svg + '<div class="spc-diagram-hint">Select a brand and model above to load real parts data</div>';
  }

  // ─── WINCH DIAGRAM IMAGE ─────────────────────────────────────────────────────
  function renderWinchSvg(parts, area) {
    var imgUrl = 'https://cdn.shopify.com/s/files/1/0879/4908/2930/files/Winch_DIagram3.png?v=1776432661';
    area.innerHTML =
      '<div style="text-align:center;padding:8px 0">' +
        '<div class="spc-diagram-img-wrap">' +
        '<img src="' + imgUrl + '" alt="Winch parts diagram" ' +
          'style="width:100%;max-width:560px;display:block;margin:0 auto;border-radius:6px"/>' +
        '</div>' +
      '</div>' +
      '';
    return;
    var ap = S.activePart;
    var svg = '<svg viewBox="0 0 1000 1200" style="display:none">';

    svg += '<defs>';
    // Stainless steel
    svg += '<linearGradient id="wSteel" x1="0" y1="0" x2="1" y2="0.3"><stop offset="0%" stop-color="#e8e8e8"/><stop offset="50%" stop-color="#b8c1cc"/><stop offset="100%" stop-color="#a0a8b3"/></linearGradient>';
    // Anodised black
    svg += '<linearGradient id="wAnod" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#4a4d55"/><stop offset="25%" stop-color="#2a2c30"/><stop offset="75%" stop-color="#1a1c1e"/><stop offset="100%" stop-color="#3d4047"/></linearGradient>';
    // Bronze
    svg += '<linearGradient id="wBronze" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#d9b66c"/><stop offset="50%" stop-color="#b5914e"/><stop offset="100%" stop-color="#94743b"/></linearGradient>';
    // Cross-hatch for cut surfaces
    svg += '<pattern id="hatch" width="8" height="8" patternUnits="userSpaceOnUse" patternTransform="rotate(45)"><line x1="0" y1="0" x2="0" y2="8" stroke="#777" stroke-width="0.8"/></pattern>';
    svg += '</defs>';

    // Engineering centre line
    svg += '<line x1="620" y1="50" x2="620" y2="1050" stroke="#ccc" stroke-width="1.5" stroke-dasharray="15,6,3,6"/>';

    // ── Part 1: Top Cap & Handle Socket (with jaw arms) ───────────────────────
    var a1 = ap === 0, o1 = (ap !== null && !a1) ? '0.2' : '1';
    svg += '<g style="cursor:pointer;opacity:' + o1 + '" onclick="window.__spcToggle(0)">';
    if (a1) svg += '<rect x="530" y="80" width="180" height="170" rx="10" fill="none" stroke="#2b9fca" stroke-width="2.5" stroke-dasharray="10,5"/>';
    svg += '<ellipse cx="620" cy="180" rx="90" ry="25" fill="url(#wSteel)" stroke="#333" stroke-width="1"/>';
    svg += '<path d="M570 160 Q530 140 540 100 L590 100 Q600 140 570 160 Z" fill="url(#wSteel)" stroke="#333"/>';
    svg += '<path d="M670 160 Q710 140 700 100 L650 100 Q640 140 670 160 Z" fill="url(#wSteel)" stroke="#333"/>';
    svg += '<circle cx="620" cy="180" r="10" fill="url(#wBronze)" stroke="#333"/>';
    svg += '<circle cx="750" cy="160" r="15" fill="' + (a1 ? '#2b9fca' : '#7a8494') + '"/>';
    svg += '<text x="750" y="160" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="14" font-weight="700" font-family="sans-serif">1</text>';
    svg += '</g>';

    // ── Part 2: Self-Tailing Drum (detailed cutaway) ──────────────────────────
    var a2 = ap === 1, o2 = (ap !== null && !a2) ? '0.2' : '1';
    svg += '<g style="cursor:pointer;opacity:' + o2 + '" onclick="window.__spcToggle(1)">';
    if (a2) svg += '<rect x="520" y="270" width="200" height="230" rx="10" fill="none" stroke="#2b9fca" stroke-width="2.5" stroke-dasharray="10,5"/>';
    svg += '<ellipse cx="620" cy="300" rx="95" ry="30" fill="#222" stroke="#000"/>';
    svg += '<rect x="525" y="300" width="190" height="170" fill="url(#wAnod)"/>';
    svg += '<path d="M620 300 Q620 350 620 470 L525 470 L525 300 Z" fill="url(#hatch)" stroke="#000"/>';
    svg += '<circle cx="750" cy="380" r="15" fill="' + (a2 ? '#2b9fca' : '#7a8494') + '"/>';
    svg += '<text x="750" y="380" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="14" font-weight="700" font-family="sans-serif">2</text>';
    svg += '</g>';

    // ── Part 3: Gear Sets & Main Shaft (bronze satellite gears) ──────────────
    var a3 = ap === 2, o3 = (ap !== null && !a3) ? '0.2' : '1';
    svg += '<g style="cursor:pointer;opacity:' + o3 + '" onclick="window.__spcToggle(2)">';
    if (a3) svg += '<rect x="420" y="520" width="400" height="200" rx="10" fill="none" stroke="#2b9fca" stroke-width="2.5" stroke-dasharray="10,5"/>';
    svg += '<ellipse cx="620" cy="620" rx="60" ry="18" fill="url(#wBronze)" stroke="#333"/>';
    svg += '<ellipse cx="620" cy="620" rx="30" ry="9" fill="url(#wBronze)" stroke="#333"/>';
    svg += '<rect x="590" y="520" width="60" height="180" fill="url(#wBronze)"/>';
    for (var gi = 0; gi < 6; gi++) {
      var gRad = gi * Math.PI / 3;
      svg += '<ellipse cx="' + (620 + Math.cos(gRad) * 45) + '" cy="' + (620 + Math.sin(gRad) * 13) + '" rx="15" ry="4" fill="url(#wBronze)" stroke="#333"/>';
    }
    svg += '<circle cx="750" cy="620" r="15" fill="' + (a3 ? '#2b9fca' : '#7a8494') + '"/>';
    svg += '<text x="750" y="620" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="14" font-weight="700" font-family="sans-serif">3</text>';
    svg += '</g>';

    // ── Part 4: Pawls & Springs Ring (isometric with ball detail) ────────────
    var a4 = ap === 3, o4 = (ap !== null && !a4) ? '0.2' : '1';
    svg += '<g style="cursor:pointer;opacity:' + o4 + '" onclick="window.__spcToggle(3)">';
    if (a4) svg += '<rect x="520" y="740" width="200" height="80" rx="10" fill="none" stroke="#2b9fca" stroke-width="2.5" stroke-dasharray="10,5"/>';
    svg += '<ellipse cx="620" cy="780" rx="80" ry="25" fill="none" stroke="url(#wAnod)" stroke-width="4"/>';
    var pawlAngles = [0, 45, 90, 135, 180, 225, 270, 315];
    for (var pi = 0; pi < pawlAngles.length; pi++) {
      var pRad = pawlAngles[pi] * Math.PI / 180;
      svg += '<circle cx="' + (620 + Math.cos(pRad) * 70) + '" cy="' + (780 + Math.sin(pRad) * 21) + '" r="4" fill="url(#wBronze)"/>';
    }
    svg += '<circle cx="750" cy="780" r="15" fill="' + (a4 ? '#2b9fca' : '#7a8494') + '"/>';
    svg += '<text x="750" y="780" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="14" font-weight="700" font-family="sans-serif">4</text>';
    svg += '</g>';

    // ── Part 5: Base Plate (detailed isometric foot) ──────────────────────────
    var a5 = ap === 4, o5 = (ap !== null && !a5) ? '0.2' : '1';
    svg += '<g style="cursor:pointer;opacity:' + o5 + '" onclick="window.__spcToggle(4)">';
    if (a5) svg += '<rect x="500" y="870" width="240" height="130" rx="10" fill="none" stroke="#2b9fca" stroke-width="2.5" stroke-dasharray="10,5"/>';
    svg += '<ellipse cx="620" cy="930" rx="100" ry="32" fill="none" stroke="url(#wSteel)" stroke-width="4"/>';
    svg += '<path d="M250 850 L310 850 L320 900 L260 900 Z" fill="url(#wSteel)" stroke="#333"/>';
    svg += '<rect x="260" y="850" width="10" height="15" fill="#555"/>';
    svg += '<circle cx="750" cy="930" r="15" fill="' + (a5 ? '#2b9fca' : '#7a8494') + '"/>';
    svg += '<text x="750" y="930" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="14" font-weight="700" font-family="sans-serif">5</text>';
    svg += '</g>';

    svg += '</svg>';
    area.innerHTML = svg + '<div class="spc-diagram-hint">Select a brand and model above to load real parts data</div>';
  }

  // ─── BLOCK DIAGRAM IMAGE ─────────────────────────────────────────────────────
  function renderBlockSvg(parts, area) {
    var imgUrl = 'https://cdn.shopify.com/s/files/1/0879/4908/2930/files/Block_Diagram.png?v=1776432862';
    area.innerHTML =
      '<div style="text-align:center;padding:8px 0">' +
        '<div class="spc-diagram-img-wrap">' +
        '<img src="' + imgUrl + '" alt="Block parts diagram" ' +
          'style="width:100%;max-width:560px;display:block;margin:0 auto;border-radius:6px"/>' +
        '</div>' +
      '</div>' +
      '';
    return;
    var svg = '<svg viewBox="0 0 500 460" style="display:none">';
    svg += '<defs>';
    svg += '<linearGradient id="mg" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#cdd2d8"/><stop offset="40%" stop-color="#a8b0ba"/><stop offset="100%" stop-color="#848c98"/></linearGradient>';
    svg += '<linearGradient id="md" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#707884"/><stop offset="100%" stop-color="#505866"/></linearGradient>';
    svg += '</defs>';
    svg += '<line x1="250" y1="15" x2="250" y2="440" stroke="#d4d8e0" stroke-width="0.5" stroke-dasharray="4 4"/>';

    // Part 1 — Swivel Shackle
    svg += '<g>';
    svg += '<path d="M234 26 A16 18 0 0 1 266 26 L266 50 L234 50 Z" fill="url(#mg)" stroke="#8a929c" stroke-width="0.8"/>';
    svg += '<rect x="234" y="48" width="32" height="8" rx="2" fill="url(#md)" stroke="#8a929c" stroke-width="0.8"/>';
    svg += '<circle cx="282" cy="36" r="9" fill="#8899aa"/>';
    svg += '<text x="282" y="36" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="10" font-weight="700" font-family="sans-serif">1</text>';
    svg += '</g>';

    // Part 2 — Block Housing (side plates)
    svg += '<g>';
    svg += '<rect x="178" y="88" width="20" height="198" rx="6" fill="url(#mg)" stroke="#8a929c" stroke-width="0.8"/>';
    svg += '<rect x="302" y="88" width="20" height="198" rx="6" fill="url(#mg)" stroke="#8a929c" stroke-width="0.8"/>';
    svg += '<rect x="178" y="88" width="144" height="20" rx="4" fill="url(#mg)" stroke="#8a929c" stroke-width="0.8"/>';
    svg += '<rect x="178" y="266" width="144" height="20" rx="4" fill="url(#mg)" stroke="#8a929c" stroke-width="0.8"/>';
    svg += '<circle cx="160" cy="187" r="9" fill="#8899aa"/>';
    svg += '<text x="160" y="187" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="10" font-weight="700" font-family="sans-serif">2</text>';
    svg += '</g>';

    // Part 3 — Sheave
    svg += '<g>';
    svg += '<circle cx="250" cy="187" r="64" fill="#d8dce4" stroke="#8a929c" stroke-width="1"/>';
    svg += '<circle cx="250" cy="187" r="52" fill="url(#mg)" stroke="#9aa0aa" stroke-width="0.6"/>';
    svg += '<circle cx="250" cy="187" r="14" fill="url(#md)" stroke="#8a929c" stroke-width="0.8"/>';
    for (var si=0; si<6; si++) {
      var sa = si * Math.PI / 3;
      svg += '<line x1="'+(250+14*Math.cos(sa)).toFixed(1)+'" y1="'+(187+14*Math.sin(sa)).toFixed(1)+'" x2="'+(250+50*Math.cos(sa)).toFixed(1)+'" y2="'+(187+50*Math.sin(sa)).toFixed(1)+'" stroke="#8a929c" stroke-width="0.8"/>';
    }
    svg += '<circle cx="340" cy="155" r="9" fill="#8899aa"/>';
    svg += '<text x="340" y="155" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="10" font-weight="700" font-family="sans-serif">3</text>';
    svg += '</g>';

    // Part 4 — Axle Pin
    svg += '<g>';
    svg += '<line x1="168" y1="187" x2="332" y2="187" stroke="#a0a8b0" stroke-width="7" stroke-linecap="round"/>';
    svg += '<circle cx="168" cy="187" r="9" fill="url(#mg)" stroke="#8a929c" stroke-width="0.8"/>';
    svg += '<circle cx="332" cy="187" r="9" fill="url(#mg)" stroke="#8a929c" stroke-width="0.8"/>';
    svg += '<circle cx="340" cy="210" r="9" fill="#8899aa"/>';
    svg += '<text x="340" y="210" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="10" font-weight="700" font-family="sans-serif">4</text>';
    svg += '</g>';

    // Part 5 — Becket / Tail
    svg += '<g>';
    svg += '<rect x="240" y="308" width="20" height="28" rx="4" fill="url(#mg)" stroke="#8a929c" stroke-width="0.8"/>';
    svg += '<circle cx="250" cy="354" r="13" fill="none" stroke="#8a929c" stroke-width="2"/>';
    svg += '<circle cx="250" cy="354" r="7" fill="url(#mg)" stroke="#8a929c" stroke-width="0.8"/>';
    svg += '<circle cx="282" cy="340" r="9" fill="#8899aa"/>';
    svg += '<text x="282" y="340" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="10" font-weight="700" font-family="sans-serif">5</text>';
    svg += '</g>';

    svg += '</svg>';
    area.innerHTML = svg + '<div class="spc-diagram-hint">Select a brand and model above to load real parts data</div>';
  }

  // ─── HATCH DIAGRAM IMAGE ─────────────────────────────────────────────────────
  function renderHatchSvg(parts, area) {
    var imgUrl = 'https://cdn.shopify.com/s/files/1/0879/4908/2930/files/Hatches_Diagram.png?v=1776433052';
    area.innerHTML =
      '<div style="text-align:center;padding:8px 0">' +
        '<div class="spc-diagram-img-wrap">' +
        '<img src="' + imgUrl + '" alt="Hatch parts diagram" ' +
          'style="width:100%;max-width:560px;display:block;margin:0 auto;border-radius:6px"/>' +
        '</div>' +
      '</div>' +
      '';
    return;
    var ap = S.activePart;
    function opac(n) { return (ap === null || ap === n) ? 1 : 0.35; }
    // active highlight ring — only drawn when that part is selected
    function ring(x, y, w, h, r) {
      if (ap === null) return '';
      return '<rect x="' + (x-3) + '" y="' + (y-3) + '" width="' + (w+6) + '" height="' + (h+6) + '" rx="' + (r+3) + '" fill="none" stroke="#3e6f9e" stroke-width="2.5" stroke-dasharray="6 3" opacity="0.7"/>';
    }

    var svg = '<svg viewBox="0 0 460 548" style="width:100%;max-width:420px;display:block;margin:0 auto">';

    // ── Defs ──────────────────────────────────────────────────────────────────
    svg += '<defs>';
    svg += '<linearGradient id="hGlass" x1="0" y1="0" x2="1" y2="1"><stop offset="0%" stop-color="#d8edf8" stop-opacity="0.93"/><stop offset="50%" stop-color="#aacde6" stop-opacity="0.80"/><stop offset="100%" stop-color="#88b2d0" stop-opacity="0.65"/></linearGradient>';
    svg += '<linearGradient id="hFrame" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#d2dce6"/><stop offset="42%" stop-color="#aebccc"/><stop offset="100%" stop-color="#8896a8"/></linearGradient>';
    svg += '<linearGradient id="hRubber" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="#4e6e4a"/><stop offset="100%" stop-color="#2e4230"/></linearGradient>';
    svg += '<linearGradient id="hEdge" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#e8f0f8"/><stop offset="100%" stop-color="#b8ccd8"/></linearGradient>';
    svg += '<filter id="hShd" x="-12%" y="-12%" width="124%" height="124%"><feDropShadow dx="0" dy="2" stdDeviation="4" flood-color="#00000028"/></filter>';
    svg += '</defs>';

    // ── Part 1 — Hatch Lid  (y 14 → 154) ────────────────────────────────────
    var op1 = opac(0);
    svg += '<g opacity="' + op1 + '" style="cursor:pointer" onclick="window.__spcToggle(0)">';
    if (ap === 0) svg += ring(108, 14, 244, 140, 11);
    svg += '<rect x="108" y="14" width="244" height="140" rx="11" fill="url(#hFrame)" stroke="#7688a0" stroke-width="1.4" filter="url(#hShd)"/>';
    svg += '<rect x="118" y="24" width="224" height="120" rx="7" fill="none" stroke="#9aacbe" stroke-width="1"/>';
    svg += '<rect x="128" y="34" width="204" height="100" rx="5" fill="url(#hGlass)" stroke="#88b0ca" stroke-width="0.8"/>';
    svg += '<line x1="142" y1="46" x2="142" y2="126" stroke="rgba(255,255,255,0.6)" stroke-width="4" stroke-linecap="round"/>';
    svg += '<line x1="158" y1="40" x2="158" y2="130" stroke="rgba(255,255,255,0.22)" stroke-width="2" stroke-linecap="round"/>';
    svg += '<circle cx="122" cy="28" r="4" fill="#8898ac" stroke="#687888" stroke-width="0.8"/>';
    svg += '<circle cx="338" cy="28" r="4" fill="#8898ac" stroke="#687888" stroke-width="0.8"/>';
    svg += '<circle cx="122" cy="144" r="4" fill="#8898ac" stroke="#687888" stroke-width="0.8"/>';
    svg += '<circle cx="338" cy="144" r="4" fill="#8898ac" stroke="#687888" stroke-width="0.8"/>';
    svg += '<circle cx="362" cy="24" r="12" fill="#3e6f9e" stroke="#fff" stroke-width="1.8"/>';
    svg += '<text x="362" y="24" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="12" font-weight="700" font-family="sans-serif">1</text>';
    svg += '</g>';

    // separator
    svg += '<line x1="180" y1="162" x2="280" y2="162" stroke="#c0d0e0" stroke-width="1" stroke-dasharray="4 4" opacity="0.6"/>';

    // ── Part 2 — Seal & Gasket  (y 172 → 200) ────────────────────────────────
    var op2 = opac(1);
    svg += '<g opacity="' + op2 + '" style="cursor:pointer" onclick="window.__spcToggle(1)">';
    if (ap === 1) svg += ring(108, 172, 244, 28, 5);
    // Gasket as a full perimeter U-profile strip
    svg += '<rect x="108" y="172" width="244" height="14" rx="5" fill="url(#hRubber)" stroke="#263c24" stroke-width="0.9"/>';
    var rx = 116; while (rx < 348) { svg += '<line x1="' + rx + '" y1="173" x2="' + rx + '" y2="185" stroke="rgba(255,255,255,0.14)" stroke-width="1.8"/>'; rx += 9; }
    svg += '<rect x="108" y="172" width="14" height="28" rx="5" fill="url(#hRubber)" stroke="#263c24" stroke-width="0.9"/>';
    svg += '<rect x="338" y="172" width="14" height="28" rx="5" fill="url(#hRubber)" stroke="#263c24" stroke-width="0.9"/>';
    svg += '<rect x="108" y="186" width="244" height="14" rx="5" fill="url(#hRubber)" stroke="#263c24" stroke-width="0.9"/>';
    var rx2 = 116; while (rx2 < 348) { svg += '<line x1="' + rx2 + '" y1="187" x2="' + rx2 + '" y2="199" stroke="rgba(255,255,255,0.14)" stroke-width="1.8"/>'; rx2 += 9; }
    svg += '<circle cx="362" cy="179" r="12" fill="#3e6f9e" stroke="#fff" stroke-width="1.8"/>';
    svg += '<text x="362" y="179" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="12" font-weight="700" font-family="sans-serif">2</text>';
    svg += '</g>';

    // separator
    svg += '<line x1="180" y1="208" x2="280" y2="208" stroke="#c0d0e0" stroke-width="1" stroke-dasharray="4 4" opacity="0.6"/>';

    // ── Part 3 — Hinge Assemblies  (y 218 → 264) ─────────────────────────────
    var op3 = opac(2);
    svg += '<g opacity="' + op3 + '" style="cursor:pointer" onclick="window.__spcToggle(2)">';
    if (ap === 2) svg += ring(108, 218, 244, 46, 8);
    // Light background band so the whole row is clickable
    svg += '<rect x="108" y="218" width="244" height="46" rx="8" fill="#f2f5f8" stroke="#d0dce8" stroke-width="0.8"/>';
    // Hinge 1
    svg += '<rect x="140" y="228" width="50" height="26" rx="6" fill="url(#hFrame)" stroke="#7688a0" stroke-width="1.1" filter="url(#hShd)"/>';
    svg += '<ellipse cx="165" cy="241" rx="11" ry="6" fill="#647888" stroke="#526070" stroke-width="0.9"/>';
    svg += '<circle cx="165" cy="241" r="4" fill="#c2d4e4"/>';
    svg += '<line x1="120" y1="241" x2="140" y2="241" stroke="#9aacbe" stroke-width="2" stroke-linecap="round"/>';
    svg += '<line x1="190" y1="241" x2="210" y2="241" stroke="#9aacbe" stroke-width="2" stroke-linecap="round"/>';
    // Hinge 2
    svg += '<rect x="270" y="228" width="50" height="26" rx="6" fill="url(#hFrame)" stroke="#7688a0" stroke-width="1.1" filter="url(#hShd)"/>';
    svg += '<ellipse cx="295" cy="241" rx="11" ry="6" fill="#647888" stroke="#526070" stroke-width="0.9"/>';
    svg += '<circle cx="295" cy="241" r="4" fill="#c2d4e4"/>';
    svg += '<line x1="250" y1="241" x2="270" y2="241" stroke="#9aacbe" stroke-width="2" stroke-linecap="round"/>';
    svg += '<line x1="320" y1="241" x2="340" y2="241" stroke="#9aacbe" stroke-width="2" stroke-linecap="round"/>';
    svg += '<circle cx="362" cy="235" r="12" fill="#3e6f9e" stroke="#fff" stroke-width="1.8"/>';
    svg += '<text x="362" y="235" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="12" font-weight="700" font-family="sans-serif">3</text>';
    svg += '</g>';

    // separator
    svg += '<line x1="180" y1="272" x2="280" y2="272" stroke="#c0d0e0" stroke-width="1" stroke-dasharray="4 4" opacity="0.6"/>';

    // ── Part 4 — Latch & Handle  (y 282 → 334) ───────────────────────────────
    var op4 = opac(3);
    svg += '<g opacity="' + op4 + '" style="cursor:pointer" onclick="window.__spcToggle(3)">';
    if (ap === 3) svg += ring(108, 282, 244, 52, 8);
    svg += '<rect x="108" y="282" width="244" height="52" rx="8" fill="#f2f5f8" stroke="#d0dce8" stroke-width="0.8"/>';
    svg += '<rect x="178" y="292" width="104" height="32" rx="8" fill="url(#hFrame)" stroke="#7688a0" stroke-width="1.1" filter="url(#hShd)"/>';
    svg += '<rect x="192" y="298" width="76" height="20" rx="5" fill="url(#hEdge)" stroke="#7a8a9a" stroke-width="0.9"/>';
    svg += '<line x1="210" y1="307" x2="250" y2="307" stroke="#8898aa" stroke-width="1.8" stroke-linecap="round"/>';
    svg += '<line x1="214" y1="312" x2="246" y2="312" stroke="#8898aa" stroke-width="1" stroke-linecap="round" opacity="0.5"/>';
    // spring indicator dots
    svg += '<circle cx="230" cy="292" r="3" fill="none" stroke="#7a9cb4" stroke-width="1.2"/>';
    svg += '<line x1="230" y1="285" x2="230" y2="289" stroke="#7a9cb4" stroke-width="1.2" stroke-dasharray="2 2"/>';
    svg += '<circle cx="362" cy="308" r="12" fill="#3e6f9e" stroke="#fff" stroke-width="1.8"/>';
    svg += '<text x="362" y="308" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="12" font-weight="700" font-family="sans-serif">4</text>';
    svg += '</g>';

    // separator
    svg += '<line x1="180" y1="342" x2="280" y2="342" stroke="#c0d0e0" stroke-width="1" stroke-dasharray="4 4" opacity="0.6"/>';

    // ── Part 5 — Frame & Surround  (y 352 → 534) ─────────────────────────────
    var op5 = opac(4);
    svg += '<g opacity="' + op5 + '" style="cursor:pointer" onclick="window.__spcToggle(4)">';
    if (ap === 4) svg += ring(82, 352, 296, 182, 11);
    svg += '<rect x="82" y="352" width="296" height="182" rx="11" fill="url(#hFrame)" stroke="#7688a0" stroke-width="1.4" filter="url(#hShd)"/>';
    svg += '<rect x="82" y="352" width="296" height="20" rx="11" fill="url(#hEdge)" stroke="#9aacbe" stroke-width="0.9"/>';
    svg += '<rect x="100" y="378" width="260" height="146" rx="8" fill="none" stroke="#8898aa" stroke-width="1" stroke-dasharray="6 3.5"/>';
    // drain slots
    svg += '<rect x="108" y="522" width="34" height="8" rx="4" fill="#6a7a8a"/>';
    svg += '<rect x="318" y="522" width="34" height="8" rx="4" fill="#6a7a8a"/>';
    // 4 mounting holes
    svg += '<circle cx="98" cy="364" r="8" fill="#7888a0" stroke="#5a6878" stroke-width="1"/>';
    svg += '<circle cx="98" cy="364" r="3.5" fill="#485868"/>';
    svg += '<circle cx="362" cy="364" r="8" fill="#7888a0" stroke="#5a6878" stroke-width="1"/>';
    svg += '<circle cx="362" cy="364" r="3.5" fill="#485868"/>';
    svg += '<circle cx="98" cy="524" r="8" fill="#7888a0" stroke="#5a6878" stroke-width="1"/>';
    svg += '<circle cx="98" cy="524" r="3.5" fill="#485868"/>';
    svg += '<circle cx="362" cy="524" r="8" fill="#7888a0" stroke="#5a6878" stroke-width="1"/>';
    svg += '<circle cx="362" cy="524" r="3.5" fill="#485868"/>';
    svg += '<circle cx="362" cy="444" r="12" fill="#3e6f9e" stroke="#fff" stroke-width="1.8"/>';
    svg += '<text x="362" y="444" text-anchor="middle" dominant-baseline="central" fill="#fff" font-size="12" font-weight="700" font-family="sans-serif">5</text>';
    svg += '</g>';

    svg += '</svg>';
    area.innerHTML = svg + '<div class="spc-diagram-hint">Select a brand and model above to load real parts data</div>';
  }

  // ─── DEMO PART INTERACTION ────────────────────────────────────────────────────
  function togglePart(idx) {
    if (S.activePart === idx) {
      S.activePart = null;
      hideDetail();
      var btn = ddGetBtn('spc-component');
      if (btn) btn.textContent = 'Select component\u2026';
    } else {
      S.activePart = idx;
      showDetail(idx);
      var part = S.currentParts[idx];
      if (part) ddSelect('spc-component', String(idx), part.ref + ' \u2014 ' + part.name);
    }
    renderDiagram();
  }

  function showDetail(idx) {
    var part   = S.currentParts[idx];
    if (!part) return;
    var detail = document.getElementById('spc-detail');
    if (!detail) return;
    detail.style.display = 'block';

    // Demo mode — show an informational description card, no fake SKU/price
    if (!S.isLive) {
      detail.innerHTML =
        '<div class="spc-detail-header">' +
          '<div>' +
            '<div class="spc-detail-title">' +
              '<span class="spc-detail-num">' + part.ref + '</span>' +
              '<span class="spc-detail-name">' + esc(part.name) + '</span>' +
            '</div>' +
            (part.desc ? '<p class="spc-detail-desc">' + esc(part.desc) + '</p>' : '') +
          '</div>' +
          '<button class="spc-detail-close" onclick="window.__spcCloseDetail()">\u00d7</button>' +
        '</div>';
      detail.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      return;
    }

    // Live mode — full product card with SKU, price, ATC
    var parentCode = part.codes.find(function (c) { return !c.included; });
    var html = '<div class="spc-detail-header">' +
      '<div>' +
        '<div class="spc-detail-title">' +
          '<span class="spc-detail-num">' + part.ref + '</span>' +
          '<span class="spc-detail-name">' + esc(part.name) + '</span>' +
        '</div>' +
        (part.desc ? '<p class="spc-detail-desc">' + esc(part.desc) + '</p>' : '') +
        (part.productUrl ? '<a href="' + esc(part.productUrl) + '" class="spc-detail-view-link" target="_blank">View full product \u2192</a>' : '') +
      '</div>' +
      '<button class="spc-detail-close" onclick="window.__spcCloseDetail()">\u00d7</button>' +
    '</div>';

    part.codes.forEach(function (code) {
      html += '<div class="spc-code-row">';
      html += '<span class="spc-code-pn' + (code.included ? ' spc-code-pn--muted' : '') + '">' + esc(code.pn) + '</span>';
      if (code.included) {
        html += '<span class="spc-code-included-badge">INCLUDED</span>';
        if (parentCode) html += '<span class="spc-code-included-with">with ' + esc(parentCode.pn) + '</span>';
      } else {
        if (code.was)   html += '<span class="spc-code-was">$' + code.was.toFixed(2) + '</span>';
        if (code.price !== null && code.price !== undefined)
                        html += '<span class="spc-code-now">$' + code.price.toFixed(2) + '</span>';
        if (code.variantId) {
          html += '<button class="spc-code-atc" onclick="window.__spcAddToCart(' + code.variantId + ', this)">Add to basket</button>';
        } else if (code.handle) {
          html += '<a href="/products/' + esc(code.handle) + '" class="spc-code-atc" style="text-decoration:none;display:inline-block;">View product</a>';
        } else {
          html += '<button class="spc-code-atc">Add to basket</button>';
        }
      }
      html += '</div>';
    });

    detail.innerHTML = html;
    detail.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function hideDetail() {
    var el = document.getElementById('spc-detail');
    if (el) el.style.display = 'none';
  }

  // ─── GLOBAL HANDLERS ─────────────────────────────────────────────────────────
  window.__spcToggle = function (idx) { togglePart(idx); };

  window.__spcCloseDetail = function () {
    S.activePart = null;
    hideDetail();
    var btn = ddGetBtn('spc-component');
    if (btn) btn.textContent = 'Select component\u2026';
    renderDiagram();
  };

  window.__spcAddToCart = function (variantId, btn) {
    if (!variantId || !btn) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 }),
    })
      .then(function (r) { if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'error'); }); return r.json(); })
      .then(function () {
        btn.textContent = 'Added \u2713';
        btn.classList.add('spc-code-atc--success');
        btn.disabled = false;
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart }, bubbles: true }));
        }).catch(function () {});
        setTimeout(function () { btn.textContent = orig; btn.classList.remove('spc-code-atc--success'); }, 2500);
      })
      .catch(function () {
        btn.textContent = 'Error \u2014 retry';
        btn.classList.add('spc-code-atc--error');
        btn.disabled = false;
        setTimeout(function () { btn.textContent = orig; btn.classList.remove('spc-code-atc--error'); }, 3000);
      });
  };

  // ─── DROPDOWN EVENT BINDING ───────────────────────────────────────────────────
  function bindDropdowns() {
    // Series panel item clicks
    var seriesPanel = ddGetPanel('spc-series');
    if (seriesPanel) {
      seriesPanel.addEventListener('click', function (e) {
        var item = e.target.closest('.spc-dd-item');
        if (!item) return;
        ddSelect('spc-series', item.dataset.value, item.textContent);
        populateModels(DD.brand, item.dataset.value);
        setDemoState();
      });
    }

    // Model panel item clicks
    var modelPanel = ddGetPanel('spc-model');
    if (modelPanel) {
      modelPanel.addEventListener('click', function (e) {
        var item = e.target.closest('.spc-dd-item');
        if (!item) return;
        var modelSlug = item.dataset.value;
        ddSelect('spc-model', modelSlug, item.textContent);
        if (!DD.brand || !DD.series || !modelSlug || !S.hierarchy) { setDemoState(); return; }

        var catNode    = S.hierarchy[SPC_CATEGORY];
        var brandNode  = catNode  && catNode.brands[DD.brand];
        var seriesNode = brandNode && brandNode.series[DD.series];
        var modelNode  = seriesNode && seriesNode.models[modelSlug];
        if (!modelNode) { setDemoState(); return; }

        var brandLabel   = (brandNode.label  || titleCase(DD.brand));
        var seriesLabel  = (seriesNode.label || titleCase(DD.series));
        var modelLabel   = (modelNode.label  || titleCase(modelSlug));
        var assemblyName = brandLabel + ' ' + seriesLabel + ' ' + modelLabel;

        if (modelNode.collectionHandle) {
          loadCollectionParts(modelNode.collectionHandle, assemblyName, modelNode.productHandles || []);
        } else if (modelNode.productHandles && modelNode.productHandles.length) {
          loadProductHandlesParts(modelNode.productHandles, assemblyName);
        } else {
          setDemoState();
        }
      });
    }

    // Component dropdown item clicks
    var componentPanel = ddGetPanel('spc-component');
    if (componentPanel) {
      componentPanel.addEventListener('click', function (e) {
        var item = e.target.closest('.spc-dd-item');
        if (!item) return;
        ddSelect('spc-component', item.dataset.value, item.textContent);
        if (S.isLive) {
          selectSubcat(item.dataset.value);
        } else {
          var idx = parseInt(item.dataset.value, 10);
          if (S.activePart === idx) {
            S.activePart = null;
            hideDetail();
          } else {
            S.activePart = idx;
            showDetail(idx);
          }
          renderDiagram();
        }
      });
    }

    // Category (Equipment Type) dropdown panel item clicks
    var categoryPanel = ddGetPanel('spc-category');
    if (categoryPanel) {
      categoryPanel.addEventListener('click', function (e) {
        var item = e.target.closest('.spc-dd-item');
        if (!item) return;
        ddSelect('spc-category', item.dataset.value, item.textContent);
        switchCategory(item.dataset.value);
      });
    }

    // Close dropdowns on outside click or scroll
    document.addEventListener('click', function () { ddCloseAll(); });
    window.addEventListener('scroll', function () { ddCloseAll(); }, { passive: true });

    // Brand top-nav pill clicks
    document.querySelectorAll('.spc-tab[data-brand]').forEach(function (tab) {
      tab.addEventListener('click', function () { selectBrandFromNav(this.dataset.brand); });
    });
  }

  // ─── BOOT ────────────────────────────────────────────────────────────────────
  function init() {
    var container = document.getElementById('spc-configurator');
    if (!container) return;
    var hierarchyUrl = container.getAttribute('data-hierarchy-url');

    setDemoState();
    bindDropdowns();

    if (hierarchyUrl) {
      fetch(hierarchyUrl, { credentials: 'same-origin', cache: 'no-cache' })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function (data) {
          S.hierarchy = data;
          var q = parseConfiguratorQuery();

          if (q.category && VALID_CATS.indexOf(q.category) !== -1) {
            SPC_CATEGORY = q.category;
          }

          var activeBrandTab = document.querySelector('.spc-tab[data-brand].spc-tab--active');
          var fallbackBrand = activeBrandTab ? activeBrandTab.dataset.brand : findFirstBrandFromNav();
          var urlBrandTab = q.brand ? document.querySelector('.spc-tab[data-brand="' + q.brand + '"]') : null;
          ACTIVE_BRAND = urlBrandTab ? q.brand : (fallbackBrand || 'harken');

          selectBrandFromNav(ACTIVE_BRAND, true);
          applySeriesModelFromUrl(q);
        })
        .catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
